// extracted by mini-css-extract-plugin
export default {"filtersContainer":"group-filters_filtersContainer__1vRIp","dropdownContainer":"group-filters_dropdownContainer__b0MV5","marginRight10":"group-filters_marginRight10__QYDuk"};